export const knowledgeArticles = [
  {
    slug: 'lebensmittel',
    title: 'Welche Lebensmittel dürfen Hunde essen?',
    seoTitle: 'Welche Lebensmittel dürfen Hunde essen? | Felix Genuss Wissen',
    metaDescription: 'Hundegerechte Lebensmittel im Überblick: geeignetes Fleisch, Gemüse, Obst und Beilagen für selbst zubereitete Hundemahlzeiten – verständlich erklärt.',
    teaser: 'Vom zarten Hähnchen bis zur feinen Karotte: Diese Zutaten eignen sich grundsätzlich für den Hundenapf.',
    kategorie: 'Zutatenwissen',
    veroeffentlicht: '2026-07-01',
    geaendert: '2026-07-01',
    sections: [
      {
        h2: 'Gut geeignete Proteinquellen',
        paragraphs: [
          'Schonend gegartes, ungewürztes Fleisch bildet bei vielen selbst zubereiteten Menüs die Grundlage. Gut geeignet sind etwa Hähnchen, Pute, Rind oder Lamm. Wichtig ist, das Fleisch vollständig durchzugaren und auf Salz, Gewürze und Saucen zu verzichten.',
        ],
        list: ['Hähnchen und Pute (ohne Haut und Knochen)', 'Rind und Lamm, mager und durchgegart', 'Gegarter Fisch ohne Gräten, zum Beispiel Lachs'],
      },
      {
        h2: 'Gemüse und Obst in hundegerechten Portionen',
        paragraphs: [
          'Viele Gemüsesorten sind für Hunde gut verträglich, wenn sie weich gegart oder fein püriert werden. Obst darf in kleinen Mengen auf den Speiseplan – Kerne und Gehäuse gehören allerdings niemals in den Napf.',
        ],
        list: ['Karotten, Zucchini und Kürbis – weich gedünstet', 'Süsskartoffeln und Kartoffeln, gekocht', 'Apfel ohne Kerne und Banane in kleinen Mengen'],
      },
      {
        h2: 'Beilagen und Sättigung',
        paragraphs: [
          'Als Beilage eignen sich gut gekochter Reis, Quinoa oder Haferflocken. Sie liefern Energie und machen das Menü bekömmlich. Wie bei jeder Zutat gilt: Die individuelle Verträglichkeit deines Hundes ist entscheidend – beobachte, was ihm guttut, und lass dich im Zweifel fachlich beraten.',
        ],
      },
    ],
  },
  {
    slug: 'gefaehrliche-lebensmittel',
    title: 'Welche Lebensmittel sind für Hunde ungeeignet oder gefährlich?',
    seoTitle: 'Gefährliche Lebensmittel für Hunde | Felix Genuss Wissen',
    metaDescription: 'Diese Lebensmittel gehören nicht in den Hundenapf: Schokolade, Zwiebeln, Weintrauben und mehr – ein verständlicher Überblick für Hundehalter.',
    teaser: 'Manches, das uns schmeckt, kann Hunden ernsthaft schaden. Diese Lebensmittel gehören nicht in den Napf.',
    kategorie: 'Sicherheit',
    veroeffentlicht: '2026-07-01',
    geaendert: '2026-07-01',
    sections: [
      {
        h2: 'Diese Lebensmittel sind tabu',
        paragraphs: [
          'Einige Lebensmittel aus unserer Küche sind für Hunde ungeeignet oder können sogar gefährlich sein. Die folgende Liste nennt die bekanntesten Beispiele – sie erhebt keinen Anspruch auf Vollständigkeit.',
        ],
        list: [
          'Schokolade und kakaohaltige Produkte',
          'Zwiebeln und Knoblauch – roh wie gekocht',
          'Weintrauben und Rosinen',
          'Avocado und Macadamianüsse',
          'Xylit (Birkenzucker) in Süssigkeiten und Zahnpflegeprodukten',
          'Alkohol, rohe Schweinefleischprodukte und gekochte Knochen',
        ],
      },
      {
        h2: 'Wenn doch etwas danebengeht',
        paragraphs: [
          'Hat dein Hund versehentlich etwas Unerlaubtes gefressen, gilt: Ruhe bewahren und zeitnah tierärztlichen Rat einholen. Beschreibe möglichst genau, was und wie viel dein Hund aufgenommen hat. Dieser Artikel ersetzt keine tierärztliche Beratung – er soll dir helfen, typische Gefahren im Alltag früh zu erkennen.',
        ],
      },
    ],
  },
  {
    slug: 'portionsgroessen',
    title: 'Portionsgrössen für kleine Hunde',
    seoTitle: 'Portionsgrössen für kleine Hunde richtig bemessen | Felix Genuss Wissen',
    metaDescription: 'Wie viel Futter braucht ein kleiner Hund? Welche Faktoren die Portionsgrösse bestimmen und warum eine individuelle Rationsberatung sinnvoll ist.',
    teaser: 'Wie viel gehört in den Napf? Die richtige Menge hängt von mehr ab als nur der Waage.',
    kategorie: 'Fütterungspraxis',
    veroeffentlicht: '2026-07-01',
    geaendert: '2026-07-01',
    sections: [
      {
        h2: 'Wovon die Futtermenge abhängt',
        paragraphs: [
          'Wie viel ein Hund fressen soll, lässt sich nicht pauschal beantworten. Gewicht, Alter, Aktivitätsniveau, Gesundheitszustand und sogar die Jahreszeit spielen eine Rolle. Ein verspielter junger Bolonka hat andere Bedürfnisse als ein gemütlicher Senior.',
        ],
      },
      {
        h2: 'Beobachten statt schätzen',
        paragraphs: [
          'Eine gute Orientierung ist die Körperkondition deines Hundes: Die Rippen sollten unter einer dünnen Fettschicht fühlbar sein, die Taille von oben erkennbar. Verändert sich das Gewicht sichtbar, lohnt sich ein Blick auf die Ration – und ein Gespräch mit deiner Tierärztin oder einem Tierernährungsberater.',
          'Bei selbst zubereitetem Futter ist eine individuelle Rationsberechnung besonders empfehlenswert, damit dein Hund mit allem Wichtigen versorgt ist. Unsere Rezeptangaben verstehen sich deshalb immer als Orientierung, nicht als fertige Fütterungsempfehlung.',
        ],
      },
    ],
  },
  {
    slug: 'futterumstellung',
    title: 'Futterumstellung leicht gemacht',
    seoTitle: 'Futterumstellung beim Hund: sanft und schrittweise | Felix Genuss Wissen',
    metaDescription: 'So gelingt die Futterumstellung beim Hund ohne Magengrummeln: schrittweise mischen, beobachten und Geduld mitbringen – verständlich erklärt.',
    teaser: 'Neues Futter braucht Zeit. So stellst du den Napf sanft um – Schritt für Schritt.',
    kategorie: 'Fütterungspraxis',
    veroeffentlicht: '2026-07-01',
    geaendert: '2026-07-01',
    sections: [
      {
        h2: 'Langsam gewinnt',
        paragraphs: [
          'Der Verdauungstrakt von Hunden schätzt Beständigkeit. Eine Umstellung von heute auf morgen kann zu Unwohlsein führen. Deshalb gilt: Das neue Futter über mehrere Tage schrittweise untermischen und den Anteil des gewohnten Futters langsam verringern.',
        ],
      },
      {
        h2: 'So gehst du vor',
        list: [
          'Tag 1–2: etwa ein Viertel neues Futter untermischen',
          'Tag 3–4: die Hälfte neu, die Hälfte gewohnt',
          'Tag 5–6: drei Viertel neu',
          'Ab Tag 7: vollständig umgestellt, wenn alles gut vertragen wird',
        ],
        paragraphs: [
          'Beobachte währenddessen Appetit, Kotabsatz und Allgemeinbefinden. Zeigt dein Hund Unverträglichkeiten, gehe einen Schritt zurück oder hole tierärztlichen Rat ein – besonders bei empfindlichen oder erkrankten Hunden.',
        ],
      },
    ],
  },
  {
    slug: 'glutenfrei',
    title: 'Warum glutenfrei?',
    seoTitle: 'Glutenfreie Ernährung für Hunde: Wann sie sinnvoll sein kann | Felix Genuss Wissen',
    metaDescription: 'Glutenfreie Hunderezepte: Was Gluten ist, wann glutenfreie Ernährung für Hunde sinnvoll sein kann – und wann nicht. Transparent und ohne Übertreibungen.',
    teaser: 'Glutenfrei ist kein Selbstzweck. Wir erklären transparent, wann es sinnvoll sein kann – und wann nicht.',
    kategorie: 'Ernährungswissen',
    veroeffentlicht: '2026-07-01',
    geaendert: '2026-07-01',
    sections: [
      {
        h2: 'Was ist Gluten überhaupt?',
        paragraphs: [
          'Gluten ist ein Klebereiweiss, das in Getreidesorten wie Weizen, Dinkel, Roggen und Gerste vorkommt. Es sorgt beim Backen für die typische Elastizität des Teigs – im Hundenapf erfüllt es jedoch keine notwendige Funktion.',
        ],
      },
      {
        h2: 'Wann kann glutenfrei sinnvoll sein?',
        paragraphs: [
          'Manche Hunde reagieren empfindlich auf glutenhaltige Getreide. In solchen Fällen kann eine glutenfreie Ernährung eine sinnvolle Option sein – etwa mit Reis, Quinoa, Hirse oder Kartoffeln als Beilage. Ob eine Unverträglichkeit vorliegt, sollte jedoch immer fachlich abgeklärt werden.',
        ],
      },
      {
        h2: 'Was glutenfrei nicht bedeutet',
        paragraphs: [
          'Glutenfrei ist nicht automatisch gesünder für jeden Hund. Viele Hunde vertragen glutenhaltige Getreide problemlos. Wir kennzeichnen unsere glutenfreien Rezepte deshalb transparent – als ehrliche Option, nicht als pauschales Versprechen. Eine Diagnose oder Therapieempfehlung können und wollen wir nicht abgeben.',
        ],
      },
    ],
  },
  {
    slug: 'snacks',
    title: 'Snacks & Leckerlis mit Mass',
    seoTitle: 'Snacks und Leckerlis für Hunde: Genuss mit Mass | Felix Genuss Wissen',
    metaDescription: 'Leckerlis für Hunde richtig einsetzen: Wie viel ist zu viel, worauf bei selbst gemachten Snacks achten – und warum weniger oft mehr ist.',
    teaser: 'Leckerlis sind Liebe in kleinen Stücken – aber auch Genuss will gelernt sein.',
    kategorie: 'Fütterungspraxis',
    veroeffentlicht: '2026-07-01',
    geaendert: '2026-07-01',
    sections: [
      {
        h2: 'Die 10-Prozent-Orientierung',
        paragraphs: [
          'Als grobe Faustregel gilt, dass Snacks und Leckerlis nur einen kleinen Teil der täglichen Futterration ausmachen sollten – häufig wird ein Anteil von höchstens etwa zehn Prozent genannt. Diese Orientierung ersetzt keine individuelle Beratung, hilft aber, die Balance zu wahren.',
        ],
      },
      {
        h2: 'Selbst gemacht schmeckt am besten',
        paragraphs: [
          'Selbst zubereitete Leckerlis haben einen charmanten Vorteil: Du weisst genau, was drin ist. Ohne Zusätze, ohne Zucker, ohne Überraschungen. In unserer Rezeptkategorie „Snacks“ entstehen nach und nach einfache Ideen für kleine Belohnungen – natürlich von Felix höchstpersönlich probiert.',
        ],
      },
    ],
  },
];
